export const SETTINGS_SECTIONS_REDUCER_ACTIONS = {
  INSERT_SECTION: 'INSERT_SECTION',
};

export const SETTINGS_SECTION_KEY_FIELD_NAME = '__SETTINGS_SECTION_KEY__';
export const SETTINGS_SECTION_ORDER_FIELD_NAME = '__SETTINGS_SECTION_ORDER__';
